import CONSTANTS from 'wmic-pe-portals-utils-js/StringConstants';

export default {
    containsAnyMotors: watercraftComponents =>
        Array.isArray(watercraftComponents) &&
        watercraftComponents.some(comp => comp.subtype === CONSTANTS.COVERAGE_NAMES.HO_WATERCRAFTMOTOR_WMIC),
};
